import React from 'react';
import Stack from '@mui/material/Stack';
import PropTypes from 'prop-types';
import InvalidateParcelle from '@/components/InvalidateParcelle';
import ParcelleSelectionCheckCtrl from '@/components/ParcelleSelectionCheck/ParcelleSelectionCheckCtrl';
import SearchEnvContraintes from '@/components/SearchEnvContraintes';
import ValidateParcelle from '@/components/ValidateParcelle';
import styles from './Toolbars.module.scss';

export default function Right({ map }) {
  return (
    <Stack spacing={2} className={styles.rightToolbar}>
      <ValidateParcelle map={map} />
      <InvalidateParcelle />
      <SearchEnvContraintes />
      <ParcelleSelectionCheckCtrl />
    </Stack>
  );
}

Right.propTypes = {
  map: PropTypes.object.isRequired,
};
